export default class TimeEntryGroupEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#time_entry_group_uuid") ? (elem.querySelector("#time_entry_group_uuid") as HTMLInputElement).value : null,
            ms_id: (elem.querySelector("#time_entry_group_ms_id") as HTMLInputElement).value,
        }
    }
}